// src/utils/paymentApiService.js
import { apiGet, apiPost, withAuth } from "./apiClient";

const assertAuth = (token) => {
	if (!token) throw new Error("Authentication token missing");
};

/**
 * GET /payment/:partner/monthly_total_revenue?month=YYYY-MM
 */
export async function getMonthlyTotalRevenue({
	partnerAlias,
	month,
	token,
	signal
}) {
	assertAuth(token);
	if (!partnerAlias || !month) {
		throw new Error("partnerAlias and month are required");
	}

	const data = await apiGet(
		`payment/${encodeURIComponent(partnerAlias)}/monthly_total_revenue`,
		{
			headers: withAuth(token),
			params: { month },
			signal
		}
	);

	return Number(data?.totalRevenue ?? 0);
}

/**
 * GET /payment/:partner/payment_details
 * Returns: { success, partner, items: [...] }
 */
export async function getPaymentDetails({ partnerAlias, token, signal }) {
	assertAuth(token);
	if (!partnerAlias) return [];

	const data = await apiGet(
		`payment/${encodeURIComponent(partnerAlias)}/payment_details`,
		{
			headers: withAuth(token),
			signal
		}
	);

	return Array.isArray(data?.items) ? data.items : [];
}

/**
 * POST /payment/:partner/payment_submit
 * Body:
 * {
 *   paymentMonth,
 *   actualRevenue,
 *   deductionAmount,
 *   invoiceStatus,
 *   paymentStatus
 * }
 */
export async function submitPaymentInfo({
	partnerAlias,
	payload,
	token,
	signal
}) {
	assertAuth(token);
	if (!partnerAlias) throw new Error("partnerAlias is required");
	if (!payload) throw new Error("payload is required");

	return apiPost(`payment/${encodeURIComponent(partnerAlias)}/payment_submit`, {
		headers: withAuth(token),
		body: payload,
		signal
	});
}
